var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('span',{attrs:{"id":"whole-part"}},[_vm._v(_vm._s(_vm.wholePart))]),(this.parts[1])?_c('span',[_vm._v(".")]):_vm._e(),_c('span',{attrs:{"id":"decimal-part"}},[_vm._v(_vm._s(_vm.decimalPart))])])
}
var staticRenderFns = []

export { render, staticRenderFns }